/* 1sttoy — mobile menu drawer (audit fix 28 Sep 2026).
   The burger is server-rendered in the header. On first open the drawer is built from its <template> and filled with
   ry-nav-mega's full, validated mobile list (#ryn-mobile). Modal behaviour: focus moves in, the rest of the page is inert,
   Esc / close / scrim close it and focus returns to the burger. */
(function () {
  'use strict';
  var burger = document.querySelector('.m-header__mobile .rym__burger') || document.querySelector('.rym__burger');
  if (!burger) return;
  var drawer = null, scrim = null, lastFocus = null, inerted = [], hideTimer = null;

  function build() {
    if (drawer) return true;
    var tpl = document.getElementById('rym-drawer-tpl');
    if (!tpl) return false;
    document.body.appendChild(tpl.content.cloneNode(true));
    tpl.parentNode.removeChild(tpl);
    drawer = document.getElementById('rym-drawer');
    scrim = document.querySelector('body > .rym__scrim');
    var body = drawer.querySelector('[data-rym-body]');
    var utils = body.querySelector('.rym__m-foot');
    var src = document.getElementById('ryn-mobile');
    if (src) {
      var list = src.querySelector('.ryn-m');
      var foot = src.querySelector('.ryn-m__foot');
      if (list) {
        body.insertBefore(list, utils);
        var groups = Array.prototype.slice.call(list.querySelectorAll('details'));
        groups.forEach(function (d) {
          d.setAttribute('name', 'ryn-m'); /* native exclusive accordion where supported */
          d.addEventListener('toggle', function () {
            if (d.open) groups.forEach(function (o) { if (o !== d && o.open) o.open = false; });
          });
        });
      }
      if (foot) body.appendChild(foot);
    }
    drawer.querySelectorAll('[data-rym-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    return true;
  }

  function isOpen() { return !!drawer && drawer.classList.contains('is-open'); }

  function open() {
    if (!build()) return;
    clearTimeout(hideTimer);
    lastFocus = document.activeElement;
    drawer.hidden = false; if (scrim) scrim.hidden = false;
    inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === drawer || el === scrim || el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.inert) return;
      el.inert = true; inerted.push(el);
    });
    void drawer.offsetWidth; /* commit the closed position so the slide-in transition runs */
    requestAnimationFrame(function () { drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); });
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('rym-locked');
    var c = drawer.querySelector('[data-rym-close]'); if (c) c.focus();
  }

  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open');
    inerted.forEach(function (el) { el.inert = false; }); inerted = [];
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('rym-locked');
    hideTimer = setTimeout(function () { if (!isOpen()) { drawer.hidden = true; if (scrim) scrim.hidden = true; } }, 450);
    var back = lastFocus && document.contains(lastFocus) && lastFocus !== document.body ? lastFocus : burger;
    back.focus();
  }

  burger.addEventListener('click', function () { isOpen() ? close() : open(); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, summary'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  window.matchMedia('(min-width: 1025px)').addEventListener('change', function (m) { if (m.matches) close(); });
})();
